import Annotation from '../formats/Annotation';
import Comment from '../formats/Comment';
import Reaction from '../formats/Reaction';

function removeMagneticWallAttributors(html: string) {
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  [Comment, Reaction, Annotation].forEach((attributor) => {
    const prefix = `${attributor.keyName}-`;
    parsed
      .querySelectorAll(`[class*="${prefix}"]`)
      .forEach((node) => attributor.remove(node as HTMLElement));
  });
  return parsed.body.innerHTML;
}

export default removeMagneticWallAttributors;
